import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BillingDeterminationItem, TransactionItem } from "../../types";

// Types
interface BillingState {
  balance: number;
  transactionsHistory: TransactionItem[];
  workOrderHistory: any[];
  billingDeterminants: BillingDeterminationItem[];
  workOrderId: string;
  billingData: any[];
  selectedBillingData: any[];
  selectedBillingDeterminant: any;
  selectedMeter: string;
  walletBalance: string;
}

// initial states
const initialState: BillingState = {
  balance: 0,
  transactionsHistory: [],
  workOrderHistory: [],
  billingDeterminants: [],
  workOrderId: "",
  billingData: [],
  selectedBillingData: [],
  selectedBillingDeterminant: null,
  selectedMeter: "",
  walletBalance: "",
};

const reducers = {
  setBalance: (state: BillingState, action: PayloadAction<number>) => {
    state.balance = action.payload;
  },
  setTransactionsHistory: (
    state: BillingState,
    action: PayloadAction<TransactionItem[]>
  ) => {
    state.transactionsHistory = action.payload;
  },
  setWorkOrderHistory: (state: BillingState, action: PayloadAction<any[]>) => {
    state.workOrderHistory = action.payload;
  },
  setBillingDeterminants: (
    state: BillingState,
    action: PayloadAction<BillingDeterminationItem[]>
  ) => {
    state.billingDeterminants = action.payload;
  },
  setWorkOrderId: (state: BillingState, action: PayloadAction<string>) => {
    state.workOrderId = action.payload;
  },
  setBillingData: (state: BillingState, action: PayloadAction<any[]>) => {
    state.billingData = action.payload;
  },
  setSelectedBillingDeterminant: (
    state: BillingState,
    action: PayloadAction<any>
  ) => {
    state.selectedBillingDeterminant = action.payload;
  },
  setSelectedBillingData: (
    state: BillingState,
    action: PayloadAction<any[]>
  ) => {
    state.selectedBillingData = action.payload;
  },
  setSelectedMeter: (state: BillingState, action: PayloadAction<string>) => {
    if (state.selectedMeter != action.payload) {
      state.balance = 0;
      state.transactionsHistory = [];
      state.workOrderHistory = [];
      state.billingDeterminants = [];
      state.workOrderId = "";
      state.billingData = [];
      state.selectedBillingData = [];
      state.selectedBillingDeterminant = null;
      state.walletBalance = "";
    }
    state.selectedMeter = action.payload;
  },
  setWalletBalance: (state: BillingState, action: PayloadAction<string>) => {
    state.walletBalance = action.payload;
  },
};

// creating billing slice
const BillingSlice = createSlice({
  name: "billing",
  initialState,
  reducers,
});

// exporting actions
export const {
  setBalance,
  setTransactionsHistory,
  setWorkOrderHistory,
  setBillingDeterminants,
  setWorkOrderId,
  setBillingData,
  setSelectedBillingData,
  setSelectedBillingDeterminant,
  setSelectedMeter,
  setWalletBalance,
} = BillingSlice.actions;

export default BillingSlice.reducer;
